
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/data",
      function () {
        return require("private-next-pages/legal/data/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/data"])
      });
    }
  